import React, {useState, useEffect} from 'react';
import {useDispatch} from 'react-redux';
import ConfirmationModal from '../Modal/Modal';
import {unlinkLinkedResponse} from '../../../actions/Document/documentactions';
import {setIsModalOpen} from '../../../actions/setismodalopen';
import {labels} from '../../../util/utils';
import ProgressBar from '../BaseComponentWrappers/MotifProgressBar';
import {raiseInformationMessage} from '../../../actions/erroractions';
import styled from 'styled-components';
import {updateIsShared, updateIsUnlink} from '../../../actions/Ares/taskDocumentActions';
import EllipsesControl from '../EllipsesControl/EllipsesControl';

export default function UnlinkLinkedResponse(props) {
	const {
		showUnlinkModal,
		currentDocument,
		engagementId,
		modalSize,
		isAresView,
		onHideUnlinkModal,
		activityShortName
	} = props;
	const [showLoading, setShowLoading] = useState(false);

	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(setIsModalOpen(true));
		return () => dispatch(setIsModalOpen(false));
	}, []);

	const onConfirmUnlink = () => {
		setShowLoading(true);
		dispatch(unlinkLinkedResponse(engagementId, currentDocument.id))
			.then(() => {
				dispatch(updateIsUnlink(currentDocument.taskId, true));
				dispatch(raiseInformationMessage(labels.unlinkInProgressInfo));
				setShowLoading(false);
				onHideUnlinkModal();
			})
			.catch(() => {
				setShowLoading(false);
				dispatch(raiseInformationMessage(labels.unlinkFailMessage));
			});
	};

	return (
		<ConfirmationModal
			show={showUnlinkModal}
			showButtons
			title={labels.unlinkModalTitle}
			confirmBtnTitle={labels.confirmLabel}
			cancelBtnTitle={labels.cancelLabel}
			onOkClick={onConfirmUnlink}
			onHide={onHideUnlinkModal}
			closeTitle={labels.closeLabel}
			modalsize={modalSize}
			modalContainerClass={`unlinkModalContainer ${showLoading && 'unlinkModalContainerLoader'}`}
			isAresView={isAresView}
			showError
		>
			<StyledUnlinkLinkedResponse className="StyledUnlinkLinkedResponse">
				{showLoading && (
					<section className="MotifProgressBarWrapper">
						<ProgressBar className="sharingActivityLoader" isIndeterminate circle hideLabel />
					</section>
				)}
				<section className="modalBodyWrapper customScrollbar">
					<section className="modalBodyDesc">{labels.unlinkModalDescription}</section>
					<section>{currentDocument.documentName}</section>
					<section className="modalBodyText">
						<EllipsesControl noOfLines={2} content={activityShortName} tooltip={activityShortName} />
					</section>
				</section>
			</StyledUnlinkLinkedResponse>
		</ConfirmationModal>
	);
}

const StyledUnlinkLinkedResponse = styled.section`
	.MotifProgressBarWrapper {
		width: 100%;
		height: calc(100% - var(--px-70));
		display: flex;
		align-items: center;
		justify-content: center;
		position: absolute;
		z-index: 9;
		background: var(--neutrals-00white) CC;
		top: var(--px-70);
		left: 0;
	}
	.modalBodyWrapper {
		min-height: 100%;
		.modalBodyDesc {
			font-size: var(--px-14) !important;
			font-weight: 300 !important;
			line-height: var(--px-24) !important;
			color: var(--neutrals-900) !important;
			padding-bottom: var(--px-24);
			border-bottom: var(--px-1) solid var(--neutrals-200);
		}
		.modalBodyText {
			padding: var(--px-24) 0 0 0;
			font-size: var(--px-14) !important;
			font-weight: 400 !important;
			line-height: var(--px-24) !important;
			color: var(--neutrals-700) !important;
		}
	}
`;
